import React from "react";

export const AcademyIcon: React.FC = () => (
  <svg width={402.62} height={399.32} viewBox="0 0 402.62 399.32">
    <path
      d="M379.09,.16L201.11,36.66,23.13,.16C11.61-1.55,.61,13.28,1.11,25.28V250.97c.5,13.14,9.5,22.27,22.02,25.12l173.68,47.73c3.14,.86,6.45,.86,9.59,0l172.68-47.73c13.52-2.85,21.52-9.7,22.02-25.12V25.28c.5-14.28-9.5-26.83-22.02-25.12Zm-5.48,232.08c0,11.64-6,13.92-14.2,16.2l-157.8,45.63L43.82,248.43c-8.2-2.28-14.2-6.84-14.2-16.2V53.43c0-8.95,7-17.34,14.2-16.2l157.3,35.36,158.3-35.36c9.2-2.28,14.2,7.25,14.2,16.2V232.23Z"
      fill="#1b3c55"
    />
    <rect x="79.17" y="160.55" width="249.88" height="32" rx="16" ry="16" transform="translate(380.66 -27.56) rotate(90)" fill="#1b3c55" />
    <path
      d="M402.62,335.22h0c-2.06-8.59-10.7-13.89-19.29-11.83l-181.81,43.62h0L19.8,322.64c-8.58-2.1-17.24,3.16-19.34,11.75h0c-2.1,8.58,3.16,17.24,11.75,19.34l184.81,45.15c1.59,.39,3.18,.52,4.73,.43,1.37,.04,2.76-.09,4.15-.42l180.71-43.36c8.8-2.11,16-11.24,16-20.29Z"
      fill="#1b3c55"
    />
  </svg>
);
